'use client';
// Import client component to give it 'use client' directive
import { ErrorBoundary as SentryErrorBoundary, type ErrorBoundaryProps } from '@sentry/react';

const ErrorBoundary = (props: ErrorBoundaryProps) => <SentryErrorBoundary {...props} />;

export default ErrorBoundary;
